const ru = {
  launchKicker: "Регистрация до запуска",
  launchTitle: "Полная версия приложения выйдет до 1 февраля 2027 года.",
  launchBody: "Сейчас мы тестируем приложение и завершаем партнёрские соглашения. Самое время для компаний, спонсоров и муниципалитетов зарегистрироваться — и получить скидку 50 % как партнёр запуска.",
  launchCta: "Зарегистрироваться",
  testApp: "Попробовать тестовую версию",
  bandKicker: "Для бизнеса",
  bandTitle: "Добавьте своих троллей — скидка 50 % для партнёров запуска.",
  bandBody: "Отели, кафе, сауны, магазины и муниципалитеты могут зарегистрироваться уже сейчас, чтобы их тролли были готовы к запуску приложения.",
  bandCta: "Стать партнёром",
  kicker: "Регистрация",
  title: "Поставьте своих троллей на карту.",
  lead: "Расскажите, кто вы, выберите пакет и отметьте троллей на карте. Вы платите через Vipps, а мы готовим ваших троллей к запуску.",
  role: "Кто вы?",
  rolePh: "Выберите…",
  roles: { homeowner: "Владелец дома или частный хозяин", municipality: "Муниципалитет, регион или турбюро", sponsor: "Спонсор", other: "Другое" },
  firstName: "Имя",
  lastName: "Фамилия",
  company: "Компания или организация",
  optional: "необязательно",
  email: "Эл. почта",
  phone: "Телефон",
  website: "Сайт",
  package: "Пакет",
  mapTitle: "Где вы хотите поставить троллей?",
  mapHint: "Найдите свой адрес и нажмите на карту, чтобы поставить тролля. Перетащите метку, чтобы переместить её.",
  search: "Поиск адреса или места в Норвегии",
  searchBtn: "Найти",
  noResults: "Ничего не найдено. Попробуйте другой запрос.",
  placed: "Размещено троллей: {n} из {max}",
  full: "Все тролли размещены — удалите одного, чтобы переместить, или выберите пакет побольше.",
  noPackage: "Сначала выберите пакет, чтобы увидеть, сколько троллей можно разместить.",
  outside: "Троллей можно размещать только в Норвегии.",
  pin: "Тролль {n}",
  remove: "Удалить",
  message: "Что нам стоит знать?",
  messagePh: "Часы работы, идеи троллей, вопросы…",
  consent: "Я согласен(на), что Trollfossjakten хранит эти данные для обработки моей заявки. См. {privacy}.",
  submit: "Зарегистрироваться и перейти к оплате",
  sending: "Отправка…",
  summary: "Ваш заказ",
  pickPackage: "Выберите пакет, чтобы увидеть цену.",
  payNote: "Оплата через Vipps после регистрации. Стартовая цена: −50 % в первый год.",
  errors: {
    phone: "Введите корректный номер телефона (цифры, +, пробелы).",
    required: "Заполните все обязательные поля.",
    email: "Введите корректный адрес эл. почты.",
    pins: "Поставьте на карту хотя бы одного тролля.",
    consent: "Подтвердите согласие на хранение данных.",
    tooMany: "Слишком много заявок с этого устройства. Попробуйте позже.",
    generic: "Что-то пошло не так. Попробуйте ещё раз.",
  },
  doneKicker: "Спасибо!",
  doneTitle: "{name}, вы зарегистрированы.",
  doneBody: "Номер вашего заказа — {ref}. Мы отправили копию на {email}. Оплатите через Vipps, чтобы закрепить стартовую цену.",
  doneBodyNoMail: "Номер вашего заказа — {ref}. Сохраните его и оплатите через Vipps, чтобы закрепить стартовую цену.",
  another: "Зарегистрировать другое место",
  payTitle: "Оплата через Vipps",
  number: "Номер Vipps",
  amount: "Сумма",
  ref: "Номер заказа",
  copy: "Копировать",
  copied: "Скопировано",
  exVat: "Цена без НДС",
  vat: "НДС 25 %",
  total: "К оплате",
  steps: ["Откройте Vipps и выберите перевод денег", "Введите номер {number}", "Введите сумму {amount} kr", "В сообщении укажите номер заказа {ref}"],
  invoice: "Нужен счёт? Ответьте на письмо с подтверждением, и мы его пришлём.",
  host: { name: "Место хозяина", for: "Кафе, ферма, домик, B&B, сауна или магазин, которые принимают охотников на троллей и Тролль-кроны", free: "Бесплатно" },
  mapTitleHost: "Где находится ваше место — или где вы планируете открыться?",
  mapHintHost: "Найдите свой адрес и нажмите на карту, чтобы поставить метку. Перетащите её, чтобы переместить.",
  placePin: "Ваше место",
  placedHost: "Отмечено мест: {n} из 1",
  fullHost: "Ваше место отмечено — перетащите метку или сначала удалите её.",
  placeTitle: "Ваше место",
  placeBody: "Расскажите охотникам на троллей, что вы предлагаете, и отметьте всё, что у вас есть.",
  offer: "Что вы будете предлагать?",
  offerPh: "например, кофе и вафли, сауна, комнаты на ночь",
  amenitiesTitle: "Что у вас есть? Отметьте всё подходящее",
  amenities: { coffee: "Кофе", tea: "Чай", snacks: "Закуски", restaurant: "Ресторан", conversations: "Общение", phone_charging: "Зарядка телефона", bike_charging: "Зарядка электровелосипеда", car_charging: "Зарядка электромобиля", shower: "Душ", room: "Комната", sauna: "Сауна", bnb: "Bed & breakfast", hotel: "Отель", camping: "Кемпинг", parking: "Парковка", toilet: "Туалет", wifi: "Wi-Fi" },
  hostNote: "Быть хозяином бесплатно — без оплаты и без регистрационного сбора. Мы проверим данные и добавим ваше место на карту.",
  submitHost: "Зарегистрироваться как хозяин",
  offerError: "Расскажите, что вы будете предлагать.",
  hostDoneTitle: "{name}, вы зарегистрированы как хозяин.",
  hostDoneBody: "Ваш номер — {ref}. Мы отправили копию на {email}. Мы проверим данные и добавим ваше место на карту.",
  hostDoneBodyNoMail: "Ваш номер — {ref}. Сохраните его — мы проверим данные и добавим ваше место на карту.",
  hostNextTitle: "Что дальше",
  hostNext: ["Скачайте приложение и войдите с тем же e-mail.", "Откройте Профиль → Стать хозяином, чтобы принимать Тролль-кроны.", "Сканируйте платёжный QR гостя — приложение само посчитает остаток к оплате."],
  hostGetApp: "Скачать приложение",
};

export default ru;
